/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line
  /*Custom Edit: This ensures that whenever the page reloads (including after pressing “Back” from cart), any disabled or invisible “Add to Cart” buttons will return to normal.*/
  function resetAddToCartButtons() {
    const addToCartButtons = document.querySelectorAll('button[id^="AddToCart"]');
    
    addToCartButtons.forEach((button) => {
      button.classList.remove('is-loading');
      button.removeAttribute('disabled');
    });
  }

  // Run when the DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    resetAddToCartButtons();
    trackAmazonButton();
  });

  // Run when page is restored from bfcache (back/forward nav)
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      resetAddToCartButtons();
    }

    console.log('Reset Add to Cart Button');
  });

  function trackAmazonButton() {
    const amazonButton = document.getElementById('amazon-revive');

    if (amazonButton !== null) {
      amazonButton.addEventListener('click', () => {
        window.fbq('track', 'GoToAmazon');
        window.gtag('event', 'go_to_amazon');
        window.ttq.track('GoToAmazon');
      });
    }
  }



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
